import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { Provider } from "react-redux";
import { ajax } from "rxjs/ajax";

import { configureStore } from "./configureStore";
import * as RoutesModule from "./routes";
import { getServerOptions, setServerOptions } from "./serverOptions";
import { ApplicationState } from "./store";
import { UserActions } from "./store/user";
import { buildVersion } from "./version";


let routes = RoutesModule.routes;

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
setServerOptions((window as any).serverOptions);
const initialState = (window as any).initialReduxState as ApplicationState;
const store = configureStore(history, initialState);

function renderApp(): void {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.hydrate(
        <AppContainer>
            <Provider store={ store }>
                <ConnectedRouter history={ history } children={ routes } />
            </Provider>
        </AppContainer>,
        document.getElementById("react-app")
    );

    if (getServerOptions().oAuthConfigs.Google || getServerOptions().oAuthConfigs.TrimbleConnect) {
        store.dispatch(UserActions.enableLogins());
        store.dispatch(UserActions.loadUser());
    }

    ajax({
        url: "api/version",
        responseType: "text"
    }).subscribe(
        response => {
            if (buildVersion !== response.response) {
                location.reload(true);
            }
        }
    );
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
    module.hot.accept("./routes", () => {
        // Justification: this is needed for hot reloading
        // tslint:disable-next-line:no-require-imports
        routes = require<typeof RoutesModule>("./routes").routes;
        renderApp();
    });
}
